import Table from '@/components/table/components/Table.tsx';
import waitlistApi from '@/features/dashboard/waitlist/api/waitlistApi.ts';
import { waitlistApiQueryKeys } from '@/features/dashboard/waitlist/api/waitlistApi.queryKeys.ts';
import {
  tourWaitlistRoute,
  tourRoute,
} from '@/features/dashboard/tours/routes/tourRoute.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { TaggableType } from '@/features/dashboard/tags/types/TaggableType.ts';

const TourWaitlistTable = () => {
  const { tourId } = tourRoute.useParams();
  const search = tourWaitlistRoute.useSearch();

  return (
    <Table
      listSearch={search}
      queryKey={waitlistApiQueryKeys.byTour(tourId)}
      fetchData={(pr, fc: FilterCriteriaDto) =>
        waitlistApi.getAll(tourId, pr, fc)
      }
      fetchTableDef={() => waitlistApi.getTableDefinition(tourId)}
      tagTargetType={TaggableType.WAITLIST_ENTRY}
      title="Lista rezerwowa"
    />
  );
};

export default TourWaitlistTable;
